/*
  Hampton Jitney car service booking (see snippets/hj-car-service-fields.liquid).

  Checks the vehicle fields before Dawn's product form adds the car to the cart. Dawn's form is marked
  novalidate, so the browser won't check required fields on its own. The listener runs in the capture
  phase on document, before the form's own submit handler, and stops the event only when a field is
  missing; otherwise Dawn adds the line with the fields attached through their form attribute.
  After a successful add it clears the vehicle details and shows a confirmation.

  Read form ids with getAttribute: Dawn's product form contains <input name="id">, and a named
  control shadows form.id, so form.id returns that input instead of the form's id.
*/
(function () {
  if (window.hjCarService) return;
  window.hjCarService = true;

  function containerFor(form) {
    var id = form instanceof HTMLFormElement ? form.getAttribute('id') : null;
    return id ? document.querySelector('[data-hj-car-form="' + CSS.escape(id) + '"]') : null;
  }

  function fieldsIn(container) {
    return container.querySelectorAll('[data-hj-car-field]');
  }

  function validate(field, container) {
    var kind = field.dataset.hjCarField;
    var isSelect = field.tagName === 'SELECT';
    var value = isSelect ? field.value : field.value.replace(/\s+/g, ' ').trim();
    var message = '';
    if (!isSelect) field.value = value;

    if (kind === 'choice') {
      if (!value) message = container.dataset.msgChoose;
    } else if (kind === 'phone') {
      var digits = value.replace(/\D/g, '').length;
      if (digits < 10 || digits > 15) message = container.dataset.msgPhone;
    } else if (kind === 'year') {
      var year = Number(value);
      if (!/^\d{4}$/.test(value) || year < 1900 || year > new Date().getFullYear() + 2) message = container.dataset.msgYear;
    } else if (!value) {
      message = container.dataset.msgRequired;
    }

    field.setCustomValidity(message || '');
    return !message;
  }

  function showStatus(container, text) {
    var status = container.querySelector('.hj-passenger__status');
    if (!status) return;
    status.textContent = text || '';
    status.hidden = !text;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var container = containerFor(event.target);
      if (!container) return;
      var fields = fieldsIn(container);
      for (var i = 0; i < fields.length; i++) {
        if (!validate(fields[i], container)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showStatus(container, '');
          fields[i].reportValidity();
          return;
        }
      }
      container.dataset.hjPending = 'true';
      showStatus(container, '');
    },
    true
  );

  function onEdit(event) {
    var field = event.target;
    if (!field.dataset || !field.dataset.hjCarField) return;
    field.setCustomValidity('');
    var container = field.closest('[data-hj-car-form]');
    if (container) showStatus(container, '');
  }
  document.addEventListener('input', onEdit);
  document.addEventListener('change', onEdit);

  function listen() {
    // subscribe() and PUB_SUB_EVENTS come from Dawn's pubsub.js and constants.js.
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      document.querySelectorAll('[data-hj-car-form][data-hj-pending]').forEach(function (container) {
        delete container.dataset.hjPending;
        fieldsIn(container).forEach(function (field) {
          if (!field.hasAttribute('data-hj-keep')) field.value = '';
        });
        showStatus(container, container.dataset.msgAdded);
      });
    });
    subscribe(PUB_SUB_EVENTS.cartError, function () {
      document.querySelectorAll('[data-hj-car-form][data-hj-pending]').forEach(function (container) {
        delete container.dataset.hjPending;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', listen);
  } else {
    listen();
  }
})();
